import { createSlice } from "@reduxjs/toolkit";

type OperationState =
  | "DRAFT"
  | "REVIEW"
  | "SUMMARY"
  | "DETAILS"
  | "CHANGE_RISK_PROFILE";

interface InitialState {
  openModal: boolean;
  operationState: OperationState;
  data: {
    account: string;
    bloombergCode: string;
    currency: string;
    fundClass: string;
    isEditOperation: boolean;
    isTotal: boolean;
    limitRate: string;
    liquidation: string;
    nominalPrice: number;
    operationType: string;
    operationValue: string;
    orderId: string;
    orderType: string;
    price: string;
    pricePerShare: number;
    rawSymbol: string;
    side: string;
    stopPrice: string;
    symbol: string;
    symbolType: string;
    error_description?: string;
    nonOperable?: boolean;
    executedQuantity: number | undefined;
    executedAmount: number | undefined;
  } | null;
}

const initialState: InitialState = {
  openModal: false,
  operationState: "DRAFT",
  data: null,
};

const operationDataSlice = createSlice({
  name: "operationData",
  initialState,
  reducers: {
    updateOperationData: (state, action) => {
      state.data = action.payload;
    },
    openOperationModal: (state) => {
      state.openModal = true;
    },
    updateOperationModal: (state, action) => {
      state.operationState = action.payload;
    },
    closeOperationModal: (state) => {
      state.openModal = false;
      state.operationState = "DRAFT"; // Reset to DRAFT when closing
    },
    resetOperationModal: (state) => {
      state.openModal = initialState.openModal;
      state.operationState = initialState.operationState;
      state.data = initialState.data;
    },
  },
});

export const {
  updateOperationData,
  openOperationModal,
  updateOperationModal,
  closeOperationModal,
  resetOperationModal,
} = operationDataSlice.actions;
export default operationDataSlice.reducer;
